// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3wQX7","inputWrap":"styles_inputWrap__2QE73","input":"styles_input__-YAXk"};